export class Permission {
    static AdminPages = new Permission('menu.admin.read');

    static CreateCompany = new Permission('companymanagement.company.create');
    static CreateLegalEntity = new Permission('companymanagement.legalentityandjurisdiction.create');
    static CreateJurisdictionObligation = new Permission('companymanagement.legalentityandjurisdiction.create');
    static EditCompanyStructure = new Permission('companymanagement.company.update');
    static DeactivateCompanyStructure = new Permission('companymanagement.company.softdelete');

    static CreateCredentials = new Permission('credentialsconfiguration.credentails.create');
    static EditCredentials = new Permission('credentialsconfiguration.credentails.update');
    static SoftDeleteCredentials = new Permission('credentialsconfiguration.credentails.delete');

    static UserCreation = new Permission('usermanagement.user.create');
    static UserUpdate = new Permission('usermanagement.user.update');
    static UserSoftDelete = new Permission('usermanagement.user.delete');

    
    static CompanyCredentialManagement = new Permission('credentialsconfiguration.credentails.read');

    constructor(public name: string) {}
}